import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import Arrow from 'src/app/icons/Monospaced/Arrow/Arrow';
import { cssVar } from 'src/app/styles/helper';
import { TextBlock } from './PricingQuizAction.styles';

export interface PricingQuizActionPros {
  text: TypographyProps;
  onClick: () => void;
}

const PricingQuizAction = ({ text, onClick }: PricingQuizActionPros): JSX.Element => (
  <Grid>
    <Grid
      maxWidthSm='width-sm'
      borderRadius='radius-2xl'
      background='bg-secondary-alt'
      overflow='hidden'
      gap='spacing-4xl'
      gapSm='spacing-xl'
      padding='spacing-xl'
      columns={12}
      totalColumnsSm={1}
      margin={['spacing-none', 'spacing-auto']}
      border='1px solid var(--border-secondary-alt)'
    >
      <TextBlock
        align='center'
        justify='flex-start'
        columns={10}
        columnsXl={9}
        columnsMd={8}
        columnsSm={1}
      >
        <Typography
          className='text-block'
          {...text}
        />
      </TextBlock>
      <Stack
        columns={2}
        columnsXl={3}
        columnsMd={4}
        columnsSm={1}
        maxWidthSm='width-fit-content'
        marginSm='spacing-auto'
      >
        <Button
          size='lg'
          variant='secondary'
          onClick={onClick}
          iconPosition='right'
          icon={
            <Arrow
              orientation='right'
              width={20}
              color={cssVar('gray-light-400')}
            />
          }
        >
          Take the Quiz
        </Button>
      </Stack>
    </Grid>
  </Grid>
);

export default PricingQuizAction;
